// AdminSchema.js
// Matches the same shape/style as PermissionGroupSchema.js

export const policyItemsFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "oldId",
    dataType: "Text",
    shownOnForm: true,
    label: "Old ID",
    value: "",
    isRequired: true,
    maxChar: 30,
    fieldType: "textfield",
    pattern: /^[0-9]+$/,
    patternMessage: "Invalid code. You can use numbers e.g 12",
  },
  {
    id: "code",
    dataType: "Text",
    shownOnForm: true,
    label: "Code",
    value: "",
    isRequired: true,
    maxChar: 30,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_\s]+$/,
    patternMessage:
      "Invalid code. You can use letters, numbers or characters such as -, _ e.g A0001-001",
  },
  {
    id: "name",
    dataType: "Text",
    shownOnForm: true,
    label: "Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "itemGroup",
    dataType: "Text",
    shownOnForm: true,
    label: "Item Group",
    value: "",
    isRequired: true,
    maxChar: 30,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_\s]+$/,
    patternMessage:
      "Invalid item group. You can use letters, numbers or characters such as -, _ e.g A0001-001",
  },
  {
    id: "percentageByCompany",
    dataType: "Text",
    shownOnForm: true,
    label: "Percentage by Company",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
    pattern: /^[0-9]+$/,
    patternMessage: "Invalid Percentage. Only numbers are allowed",
  },
  {
    id: "percentageByBeneficiary",
    dataType: "Text",
    shownOnForm: true,
    label: "Percentage Payable by Beneficiary",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
    pattern: /^[0-9]+$/,
    patternMessage: "Invalid Percentage. Only numbers are allowed",
  },
  {
    id: "status",
    dataType: "Text",
    shownOnForm: true,
    label: "Status",
    value: "active",
    isRequired: true,
    maxChar: 50,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
    ],
  },
];

export const policyItemsRecord = {
  id: 0,
  oldId: 0,
  code: "",
  name: "",
  itemGroup: "",
  status: "active",
  percentageByCompany: 0.0,
  percentageByBeneficiary: 0.0,
};
